<template>
  <div>
    <ficha-layout
      title="Ginecología (Primera consulta)"
      color="#f69bab"
      :tabs="tabs"
      :tab-default="tabDefault"
    >
      <template #preclinica>
        <pre-clinica></pre-clinica>
      </template>
      <template #antecedentes>
        <antecedentes></antecedentes>
      </template>
      <template #consulta>
        <consulta></consulta>
      </template>
      <template #tratamiento>
        <tratamiento></tratamiento>
      </template>
      <template #adjuntos>
        <adjuntos></adjuntos>
      </template>
      <template #historial>
        <historial></historial>
      </template>
      <template #resumen>
        <resumen></resumen>
      </template>
      <template #seguimiento>
        <seguimiento></seguimiento>
      </template>
    </ficha-layout>
  </div>
</template>

<script>
import FichaLayout from '../components/FichaLayout.vue';
import PreClinica from '../components/PreClinica.vue';
import Antecedentes from '../components/Antecedentes.vue';
import Consulta from './components/Consulta.vue';
import Tratamiento from '../components/Tratamiento.vue';
import Adjuntos from '../components/Adjuntos.vue';
import Historial from '../components/HistorialPr.vue';
import Resumen from '../components/Resumen.vue';
import Seguimiento from '../components/Seguimiento.vue';

export default {
  components: {
    FichaLayout,
    PreClinica,
    Antecedentes,
    Consulta,
    Tratamiento,
    Adjuntos,
    Historial,
    Resumen,
    Seguimiento,
  },
  props: {
    tabDefault: {
      default: 'preclinica',
      type: String,
    },
  },
  data() {
    return {
      tabs: {
        preclinica: { icon: 'fas fa-heart-circle-check', name: 'Pre clínica' },
        antecedentes: { icon: 'fas fa-history', name: 'Antecedentes' },
        tratamiento: { icon: 'fas fa-file-prescription', name: 'Tratamiento' },
        consulta: { icon: 'fas fa-stethoscope', name: 'Ginecología (Primera consulta)' },
        adjuntos: { icon: 'fas fa-paperclip', name: 'Adjuntos' },
        historial: { icon: 'fas fa-history', name: 'Historial' },
        resumen: { icon: 'fas fa-check', name: 'Resumen' },
        seguimiento: { icon: 'fa-solid fa-user-clock', name: 'Seguimiento' },
      },
    };
  },
};
</script>